import { render, staticRenderFns } from "./PopupCreateOrUpdateChecklistItem.vue?vue&type=template&id=24547b0e&scoped=true&"
import script from "./PopupCreateOrUpdateChecklistItem.vue?vue&type=script&lang=js&"
export * from "./PopupCreateOrUpdateChecklistItem.vue?vue&type=script&lang=js&"
import style0 from "./PopupCreateOrUpdateChecklistItem.vue?vue&type=style&index=0&id=24547b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24547b0e",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DeviceChecklistTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fdevice%2FPopupCreateOrUpdateChecklistItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports